import {FunctionComponent} from "react";

export const Line: FunctionComponent<{active: boolean}> = ({active}) => (
    <span className={`w-full h-px block ${active ? 'bg-green' : 'bg-gray'}`}/>
)